import { defineComponent, ref } from 'vue';
import SearchControl from './RoomSearch/SearchControl.vue';
import CameraControl from './RoomCamera/CameraControl.vue';
import ReactionControl from './RoomReaction/ReactionControl.vue';
import RoomSpiderwebControl from './RoomSpiderweb/RoomSpiderwebControl.vue';
import RoomLaserCrossControl from './RoomLaserCross/RoomLaserCrossControl.vue';
import RoomRepeatControl from './RoomRepeat/RoomRepeatControl.vue';
import RoomGridControl from './RoomGrid/RoomGridControl.vue';
import RoomKeypadControl from './RoomKeypad/RoomKeypadControl.vue';
import GameStateChanger from '../RoomDebug/GameStateChanger.vue';
import { TextInput, Button } from '@/components/UI';
import { GameType, GameState } from '@/types/rooms';
import Icon from '@/components/UI/Icon/Icon.vue';
export default defineComponent({
    name: 'RoomControl',
    components: {
        SearchControl,
        ReactionControl,
        RoomSpiderwebControl,
        RoomGridControl,
        RoomRepeatControl,
        RoomKeypadControl,
        RoomLaserCrossControl,
        CameraControl,
        GameStateChanger,
        TextInput,
        Button,
        Icon
    },
    props: {
        roomid: {
            type: String,
            required: true
        }
    },
    setup() {
        const spiderRef = ref(null);
        return { spiderRef };
    },
    data: () => ({
        config: null,
        status: null,
        message: ''
    }),
    computed: {
        roomType() {
            if (this.config) {
                return this.config.type;
            }
            return GameType.Unknown;
        },
        gameState() {
            if (this.status) {
                return this.status.state;
            }
            return GameState.Stopped;
        },
        isCluedo() {
            return this.roomType === GameType.Cluedo;
        },
        isReaction() {
            return this.roomType === GameType.Reaction;
        },
        isCamera() {
            return this.roomType === GameType.Camera;
        },
        isSpiderWeb() {
            return this.roomType === GameType.SpiderWeb;
        },
        isRepeat() {
            return this.roomType === GameType.Repeat;
        },
        isGrid() {
            return this.roomType === GameType.Grid;
        },
        isKeypad() {
            return this.roomType === GameType.Keypad;
        },
        isLaserCross() {
            return this.roomType === GameType.LaserCross;
        }
    },
    watch: {
        roomid: {
            immediate: true,
            handler(newRoomId) {
                this.$store.direct.dispatch.rooms.subscribe(newRoomId).then(() => {
                    var _a, _b;
                    this.config = (_a = this.$store.direct.state.rooms.config[newRoomId]) !== null && _a !== void 0 ? _a : null;
                    this.status = (_b = this.$store.direct.state.rooms.status[newRoomId]) !== null && _b !== void 0 ? _b : null;
                }).catch(error => {
                    console.error('Could not subscribe in RoomConfig', error);
                });
                this.scaleControl();
            }
        }
    },
    mounted() {
        this.$store.direct.dispatch.rooms.subscribe(this.roomid).then(() => {
            var _a, _b;
            this.config = (_a = this.$store.direct.state.rooms.config[this.roomid]) !== null && _a !== void 0 ? _a : null;
            this.status = (_b = this.$store.direct.state.rooms.status[this.roomid]) !== null && _b !== void 0 ? _b : null;
        }).catch(error => {
            console.error('Could not subscribe in RoomConfig', error);
        });
        this.scaleControl();
    },
    beforeDestroy() {
        this.$store.direct.dispatch.rooms.unsubscribe(this.roomid);
    },
    methods: {
        async sendMessage() {
            await this.$store.direct.dispatch.rooms.sendMessage({
                message: this.message,
                code: 'info',
                roomId: this.roomid,
                expire: 10
            });
            this.message = '';
        },
        async waitForElement(refName, timeout = 2000) {
            var _a;
            const start = Date.now();
            while (Date.now() - start < timeout) {
                const el = (_a = this[refName]) === null || _a === void 0 ? void 0 : _a.$el;
                if (el)
                    return el;
                await new Promise(resolve => setTimeout(resolve, 50));
            }
            return null;
        },
        async scaleControl() {
            const el = await this.waitForElement('spiderRef');
            if (!el)
                return;
            const parent = document.querySelector('.control');
            if (!parent)
                return;
            const child = el.querySelector('canvas');
            if (!child)
                return;
            const scale = parent.clientWidth / child.offsetWidth;
            child.style.transform = `scale(${scale})`;
            child.style.transformOrigin = 'top left';
            parent.style.height = `${child.offsetHeight * scale}px`;
            console.log('Scaled spiderweb to', scale);
        }
    }
});
